<div *ngIf="textoTooltip!=='sms'" class="tooltip-sqp" [ngClass]="posicion">
    <p style="font-size: 12px; margin: 6px 0">{{textoTooltip}}</p>
    <i></i>
</div>

<div *ngIf="textoTooltip==='sms'" class="tooltip-sqp" [ngClass]="posicion">
    <p style="font-size: 12px; margin: 6px 0">Amplia tus opciones de envío adquiriendo el envío por SMS.
    <br>
    Consulta <a href="https://soporte.hireandsign.com/support/solutions/articles/101000481322-configuraci%C3%B3n-de-un-dossier" target="_blank">nuestra documentación</a> para más detalles.</p>
    <i></i>
</div>



